import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=77ccfa42"
import script from "./Branding.vue?vue&type=script&lang=js"
export * from "./Branding.vue?vue&type=script&lang=js"
import style0 from "./Branding.vue?vue&type=style&index=0&id=77ccfa42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports